// import React, { useEffect, useState } from "react";
// import { Tooltip } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link, useNavigate } from "react-router-dom";
// import PaginationComponent from "../../../Components/PaginationComponent";
// import toast from 'react-hot-toast';
// import saleService from "../../../Services/saleService";
// import InvocieModalbyServices from "../../../Components/InvocieModalbyServices";

// const ServicesSales = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [patients, setPatients] = useState([]);
//   const [groupedData, setGroupedData] = useState({});
//   const [selectedInvoice, setSelectedInvoice] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [voucherData, setVoucherData] = useState({ salesCount: 0, totalAmount: 0 });
//   const [showVoucherForm, setShowVoucherForm] = useState(false);

//   useEffect(() => {
//     const getSales = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchAllServicesSale();
//         const sales = response.sales || [];
//         setPatients(sales);
//         // Group data by invoice number
//         const grouped = sales.reduce((acc, item) => {
//           if (!acc[item.invoice]) acc[item.invoice] = [];
//           acc[item.invoice].push(item);
//           return acc;
//         }, {});
//         setGroupedData(grouped);

//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching Patients");
//       }
//     };
//     getSales();
//   }, []);

//   useEffect(() => {
//     const filteredResult = Object.entries(groupedData)
//       .filter(([invoice, items]) => {
//         return items.some((item) => {
//           const itemDate = new Date(item.sale_date).setHours(0, 0, 0, 0); // Normalize to avoid time mismatch
//           const start = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : null;
//           const end = endDate ? new Date(endDate).setHours(0, 0, 0, 0) : null;
  
//           const isWithinDateRange =
//             (!start || start <= itemDate) && (!end || itemDate <= end);
  
//           return (
//             item?.patient_name
//               ?.toLowerCase()
//               .includes(searchData.toLowerCase()) && isWithinDateRange
//           );
//         });
//       })
//       .map(([invoice, items]) => ({ invoice, items }));
//     setFilteredData(filteredResult);
//     setCurrentPage(1);

//     // Calculate sales count and total amount for the filtered data
//     const salesCount = filteredResult.reduce((acc, { items }) => acc + items.length, 0);
//     const totalAmount = filteredResult.reduce(
//       (acc, { items }) => acc + items.reduce((sum, item) => sum + item.quantity * item.unit_price, 0),
//       0
//     );
//     setVoucherData({ salesCount, totalAmount });
//   }, [searchData, startDate, endDate, groupedData]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const formatDate = (dateString) => {
//     if (!dateString) return ""; // Handle null or undefined
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return new Date(dateString).toLocaleDateString("en-US", options);
//   };

//   const handleVoucherFormToggle = () => {
//     setShowVoucherForm(!showVoucherForm);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[24px] text-gray-700 font-[700]">
//           Manage Medicine Sales Record
//         </h1>
//         <h1 className="ml-[3%] text-[9px] bg-[#F07F1B] py-[3px] text-center rounded-full w-24 text-white font-bold">
//           {filteredData.length || 0} records found
//         </h1>

//         <div className="flex mt-8 flex-row-reverse justify-between ml-[3%]">
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>

//           <div className="space-x-4">
//             <input
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               className="bg-white text-black font-medium border py-2 px-4 rounded-full duration-300"
//               placeholder="Start Date"
//               title="Select the Start Date"
//             />
//             <input
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               className="bg-white text-black font-medium border py-2 px-4 rounded-full duration-300"
//               placeholder="End Date"
//               title="Select the End Date"
//             />
//             <button
//               onClick={() => {
//                 setStartDate("");
//                 setEndDate("");
//               }}
//               className="bg-white text-[#F07F1B] font-semibold border hover:bg-[#F07F1B] hover:text-white py-2 px-8 rounded-full duration-300"
//             >
//               Show All
//             </button>
//           </div>
//         </div>

//         <div className="mx-[3%] rounded-lg">
//           <table className="w-[100%] rounded-lg overflow-hidden">
//             <thead className="bg-gray-700">
//               <tr className="text-white capitalize leading-normal text-[12px] text-center">
//                 <th className="py-4 w-[15%] text-left pl-4">
//                   Invoice
//                 </th>
//                 <th className="py-4 w-[20%] text-left">
//                   Patient Name
//                 </th>
//                 <th className="py-4 w-[15%] text-left">
//                   Total Items
//                 </th>
//                 <th className="py-4 w-[15%]">
//                   Total Amount
//                 </th>
//                 <th className="py-4 w-[20%]">
//                   Sale Date
//                 </th>
//                 <th className="py-4 w-[15%]">
//                   Action
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData.map(({ invoice, items }) => (
//                 <tr
//                   key={invoice}
//                   className="bg-white text-gray-600 text-xs font-light border-t-[1px] border-gray-200"
//                 >
//                   <td className="w-[15%] text-left">
//                     <p className=" pl-4">
//                       {invoice}
//                     </p>
//                   </td>
//                   <td className="py-4 w-[20%] text-left">
//                     <p className="font-[600]">
//                       {items[0]?.patient_name}
//                     </p>
//                   </td>
//                   <td className="py-4 w-[15%] text-left">
//                     <p>
//                       {items.length}
//                     </p>
//                   </td>
//                   <td className="py-4 px-2 w-[15%] text-center">
//                     <span className="font-[600]">
//                       {items.reduce(
//                         (acc, item) => acc + item.quantity * item.unit_price,
//                         0
//                       )}
//                     </span>
//                   </td>
//                   <td className="py-4 w-[15%] text-center">
//                     <p className="text-gray-600">
//                       {formatDate(items[0]?.sale_date)}
//                     </p>
//                   </td>
//                   <td className="px-2 w-[15%] text-center">
//                     <button
//                       className="bg-gray-100 hover:bg-gray-200 text-black px-4 py-1 rounded-md border-2"
//                       onClick={() => {
//                         // Extract invoice number and patient name
//                         const invoiceNumber = items[0]?.invoice;
//                         const patientName = items[0]?.patient_name;
//                         const doctorName = items[0]?.doctor_name;
//                         const patientAddress = items[0]?.patient_address;
//                         const sale_date = items[0]?.sale_date;

//                         // Set selectedInvoice with the data and also pass the invoice number and patient name
//                         setSelectedInvoice({
//                           invoiceNumber,
//                           patientName,
//                           doctorName,
//                           patientAddress,
//                           sale_date,
//                           invoiceData: items,
//                         });
//                       }}
//                     >
//                       View Invoice
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           filteredData={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />

//         <div className="mt-4">
//         {startDate && endDate && (
//           <button
//             onClick={handleVoucherFormToggle}
//             className="bg-blue-500 text-white py-2 px-4 rounded-md"
//           >
//             Create Voucher
//           </button>
//           )}
          
//           {showVoucherForm && (
//             <div className="mt-4 p-4 bg-gray-100 rounded-md">
//               <h3 className="font-semibold text-lg">Voucher Form</h3>
//               <p>Total Sales: {voucherData.salesCount}</p>
//               <p>Total Amount: {voucherData.totalAmount}</p>
//               {/* Additional form fields to handle voucher creation can be added here */}
//             </div>
//           )}
//         </div>
//       </div>

//       {selectedInvoice && (
//         <InvocieModalbyServices
//           invoiceNumber={selectedInvoice.invoiceNumber}
//           patientName={selectedInvoice.patientName}
//           doctorName={selectedInvoice.doctorName}
//           patientAddress={selectedInvoice.patientAddress}
//           sale_date={selectedInvoice.sale_date}
//           invoiceData={selectedInvoice.invoiceData}
//           onClose={() => setSelectedInvoice(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default ServicesSales;



import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import saleService from "../../../Services/saleService";
import InvocieModalbyServices from "../../../Components/InvocieModalbyServices";

const ServicesSales = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [groupedData, setGroupedData] = useState({});
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [voucherData, setVoucherData] = useState({ salesCount: 0, totalAmount: 0 });
  const [showVoucherForm, setShowVoucherForm] = useState(false);

  useEffect(() => {
    const getSales = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllServicesSale();
        const sales = response.sales || [];
        const grouped = sales.reduce((acc, item) => {
          if (!acc[item.invoice]) acc[item.invoice] = [];
          acc[item.invoice].push(item);
          return acc;
        }, {});
        setGroupedData(grouped);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching Sales");
      }
    };
    getSales();
  }, []);

  useEffect(() => {
    const filteredResult = Object.entries(groupedData)
      .filter(([invoice, items]) =>
        items.some((item) => {
          const itemDate = new Date(item.sale_date).setHours(0, 0, 0, 0);
          const start = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : null;
          const end = endDate ? new Date(endDate).setHours(0, 0, 0, 0) : null;
          const isWithinDateRange =
            (!start || start <= itemDate) && (!end || itemDate <= end);
          return (
            item?.patient_name?.toLowerCase().includes(searchData.toLowerCase()) &&
            isWithinDateRange
          );
        })
      )
      .map(([invoice, items]) => ({ invoice, items }));

    setFilteredData(filteredResult);
    setCurrentPage(1);

    const salesCount = filteredResult.reduce((acc, { items }) => acc + items.length, 0);
    const totalAmount = filteredResult.reduce(
      (acc, { items }) =>
        acc + items.reduce((sum, item) => sum + item.quantity * item.unit_price, 0),
      0
    );
    setVoucherData({ salesCount, totalAmount });
  }, [searchData, startDate, endDate, groupedData]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="p-6">
      {/* HEADER */}
      <div className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-6 py-4 mb-5 shadow-sm">
        <div>
          <h1 className="text-[17px] font-[500] text-gray-800">
            Services Sales Record
          </h1>
          <p className="text-[12px] text-gray-400 mt-0.5">
            {filteredData.length || 0} records found
          </p>
        </div>

        <div className="flex items-center gap-3 flex-wrap justify-end">
          {/* Date Filters */}
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px] focus:outline-none text-gray-700"
            title="Start Date"
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px] focus:outline-none text-gray-700"
            title="End Date"
          />
          {(startDate || endDate) && (
            <button
              onClick={() => { setStartDate(""); setEndDate(""); }}
              className="text-[13px] bg-gray-100 hover:bg-gray-200 text-gray-600 px-3 py-[7px] rounded-lg transition-colors"
            >
              Clear
            </button>
          )}

          {/* Search */}
          <div className="relative">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search by patient..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-8 pr-3 py-[7px] w-[200px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
            />
          </div>

          {/* Voucher button */}
          {startDate && endDate && (
            <button
              onClick={() => setShowVoucherForm(!showVoucherForm)}
              className="bg-gray-800 hover:bg-gray-700 text-white text-[13px] px-4 py-[7px] rounded-lg transition-colors"
            >
              Create Voucher
            </button>
          )}
        </div>
      </div>

      {/* VOUCHER PANEL */}
      {showVoucherForm && (
        <div className="bg-white border border-gray-200 rounded-xl px-6 py-4 mb-5 shadow-sm">
          <h3 className="text-[14px] font-[500] text-gray-800 mb-2">Voucher Summary</h3>
          <p className="text-[13px] text-gray-600">Total Sales: <span className="font-semibold">{voucherData.salesCount}</span></p>
          <p className="text-[13px] text-gray-600">Total Amount: <span className="font-semibold">{voucherData.totalAmount}</span></p>
        </div>
      )}

      {/* TABLE */}
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-800 text-[11px] uppercase text-white">
              <th className="py-3 px-4 text-left">Invoice</th>
              <th className="py-3 px-4 text-center">Sale Date</th>
              <th className="py-3 px-4 text-center">Sale Time</th>
              <th className="py-3 px-4 text-left">Patient Name</th>
              <th className="py-3 px-4 text-center">Total Items</th>
              <th className="py-3 px-4 text-center">Total Amount</th>
              
              <th className="py-3 px-4 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="py-10 text-center text-gray-400 text-[13px]">
                  Loading...
                </td>
              </tr>
            ) : paginatedData.length === 0 ? (
              <tr>
                <td colSpan={6} className="py-10 text-center text-gray-400 text-[13px]">
                  No records found
                </td>
              </tr>
            ) : (
              paginatedData.map(({ invoice, items }) => (
                <tr
                  key={invoice}
                  className="border-t hover:bg-gray-50 text-[13px]"
                >
                  <td className="py-3 px-4 text-gray-500">{invoice}</td>
                    <td className="py-3 px-4 text-center text-gray-600">
                    {formatDate(items[0]?.sale_date)}
                  </td>
                  <td className="py-3 px-4 text-center text-gray-600">
                    {items[0]?.sale_date
                      ? new Date(items[0].sale_date).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                      : "—"}
                  </td>
                  <td className="py-3 px-4 font-[500] text-gray-800">
                    {items[0]?.patient_name}
                  </td>
                  <td className="py-3 px-4 text-center text-gray-600">
                    {items.length}
                  </td>
                  <td className="py-3 px-4 text-center font-[500] text-gray-800">
                    {items.reduce(
                      (acc, item) => acc + item.quantity * item.unit_price,
                      0
                    )}
                  </td>
                
                  <td className="py-3 px-4 text-center">
                    <button
                      onClick={() =>
                        setSelectedInvoice({
                          invoiceNumber: items[0]?.invoice,
                          patientName: items[0]?.patient_name,
                          doctorName: items[0]?.doctor_name,
                          patientAddress: items[0]?.patient_address,
                          sale_date: items[0]?.sale_date,
                          invoiceData: items,
                        })
                      }
                      className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100 transition-colors"
                    >
                      View Invoice
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      {selectedInvoice && (
        <InvocieModalbyServices
          invoiceNumber={selectedInvoice.invoiceNumber}
          patientName={selectedInvoice.patientName}
          doctorName={selectedInvoice.doctorName}
          patientAddress={selectedInvoice.patientAddress}
          sale_date={selectedInvoice.sale_date}
          invoiceData={selectedInvoice.invoiceData}
          onClose={() => setSelectedInvoice(null)}
        />
      )}
    </div>
  );
};

export default ServicesSales;